import styled from 'styled-components';
import IconMoreOutline from './IconMoreOutline';
var IconMoreVerticalOutline = /*#__PURE__*/styled(IconMoreOutline).withConfig({
  displayName: "IconMoreVerticalOutline",
  componentId: "c11n-8-111-1__sc-1msz84c-0"
})(["transform:rotate(90deg);"]);
export default IconMoreVerticalOutline;